import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import CardDropdown from "components/common/CardDropdown";
import ConfirmationModal from "components/common/custom/confirmation-modal";
import FalconPagination from "components/common/custom/pagination";
import IconButton from "components/common/IconButton";
import useAdvanceTable from "hooks/useAdvanceTable";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import React, { useEffect, useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { Gear, Pen, Pencil } from "react-bootstrap-icons";
import { useDispatch } from "react-redux";
import { setIndividualRole } from "../config/RoleSlice";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";
import { DeleteRole, GetAllRoleList } from "../config/RoleApi";
import { toast } from "react-toastify";

const RolesListTable = ({
  data,
  totalRows,
  handlePageChange,
  handlePerRowsChange,
  page,
  rowsPerPage,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [modalRow, setModalRow] = useState(null);
  const handleViewRole = (row) => {
    dispatch(setIndividualRole(row));
    navigate(`${paths.systemPrivillage}/add/${row?.role_id}/view`);
  };
  const handleEditRole = (row) => {
    dispatch(setIndividualRole(row));
    navigate(`${paths.systemPrivillage}/add/${row?.role_id}`);
  };

  const handleConfirmDelete = async () => {
    const response = await dispatch(DeleteRole(modalRow?.role_id)).unwrap();
    if (response?.success) {
      const body = {
        start_point: 0,
        limit: rowsPerPage,
      };
      toast.success(response?.message_en);
      const res = await dispatch(GetAllRoleList(body)).unwrap();
    } else {
      toast.error(response?.message_en);
    }
  };
  const columns = [
    {
      accessorKey: "index",
      header: "#",
      cell: ({ row }) => (
        <div className="d-flex align-items-center w-100">
          <div
            className="rounded-circle bg-200 d-flex flex-center fs-11"
            style={{ width: "30px", height: "30px" }}
          >
            {page * rowsPerPage + row.index + 1}
          </div>
        </div>
      ),
    },
    {
      accessorKey: "id",
      header: "ID ",
      cell: ({ row: { original } }) => `${original?.role_id || ""}`,
    },
    {
      accessorKey: "name",
      header: "name ",
      cell: ({ row: { original } }) => `${original?.role_name || ""}`,
    },
    {
      accessorKey: "actions",
      header: <Gear />,
      enableSorting: false,
      cell: ({ row: { original } }) => {
        return (
          <CardDropdown
            icon="ellipsis-v"
            dropdownClassName="py-2 custom-dropdown-menu"
          >
            <Dropdown.Item onClick={() => handleViewRole(original)}>
              <FontAwesomeIcon icon="eye" className="me-2" />
              View
            </Dropdown.Item>

            <Dropdown.Item onClick={() => handleEditRole(original)}>
              <Pen className="me-2" />
              Edit
            </Dropdown.Item>

            <Dropdown.Item
              onClick={() => {
                setShowDeleteModal(true);
                setModalRow(original);
              }}
            >
              <FontAwesomeIcon icon="trash" className="me-2" />
              Delete
            </Dropdown.Item>
          </CardDropdown>
        );
      },
    },
  ];

  const table = useAdvanceTable({
    data,
    columns,
    manualPagination: true,
    pageCount: Math.ceil(totalRows / rowsPerPage),
    state: {
      pagination: {
        pageIndex: page,
        pageSize: rowsPerPage,
      },
    },
  });

  useEffect(() => {
    table.setPagination({ pageIndex: page, pageSize: rowsPerPage });
  }, [page, rowsPerPage]);

  return (
    <div className="mb-3 mt-3 border">
      {data?.length > 0 ? (
        <>
          <AdvanceTableProvider {...table}>
            <AdvanceTable
              tableProps={{
                size: "sm",
                className: "fs-10 mb-0 overflow-hidden",
                striped: true,
              }}
              headerClassName="bg-200 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
            />
          </AdvanceTableProvider>
          <Card.Footer className="d-flex mt-2 mb-3 justify-content-end align-items-center">
            <FalconPagination
              currentPage={page}
              rowsPerPage={rowsPerPage}
              totalRecords={totalRows}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePerRowsChange}
            />
          </Card.Footer>
        </>
      ) : (
        <div className="text-center py-3">No Data To Show</div>
      )}
      <ConfirmationModal
        modal={showDeleteModal}
        setModal={setShowDeleteModal}
        onConfirm={handleConfirmDelete}
        title="Confirm Delete"
        description="Are you sure you want to delete this role?"
      />
    </div>
  );
};

export default RolesListTable;
